import * as api from 'api/marketplace/revenue/referral';
import {
  selectReferralRevenueQueryString,
  referralRevenueActions,
} from 'features/revenue/referral/referralRevenueSlice';
import { toastAction } from 'features/toast/toastSlice';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

const {
  initialize,
  loadDataSuccess,
  loadDataFailure,
  search,
  loadData,
  resetFilter,
  setSortType,
  pageChange,
} = referralRevenueActions;

function* updateDataSaga() {
  yield put(loadData());
}

function* loadDataSaga() {
  const query: string = yield select(selectReferralRevenueQueryString);
  const { data, error } = yield call(api.getReferralRevenue, query);
  if (error) {
    yield put(toastAction.errorResponse(error));
    yield put(loadDataFailure());
    return;
  }
  yield put(loadDataSuccess(data));
}

export default function* referralRevenueSaga() {
  yield all([
    takeLatest(loadData, loadDataSaga),
    takeLatest(initialize, updateDataSaga),
    takeLatest(search, updateDataSaga),
    takeLatest(resetFilter, updateDataSaga),
    takeLatest(setSortType, updateDataSaga),
    takeLatest(pageChange, updateDataSaga),
  ]);
}
